import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    ViewChild,
    ViewContainerRef,
    computed,
    inject
} from '@angular/core';

import { BreakpointService } from 'src/app/services/breakpoint.service';
import { ComponentItem } from 'src/app/types/component';
import { DynamicComponent } from 'src/app/types/dynamic.component';

/**
 * Display a dynamic list of components
 *
 * @class DynamicListComponent
 * @typedef {DynamicListComponent}
 * @implements {OnChanges}
 */
@Component( {
    selector: 'riege-dynamic-list',
    standalone: true,
    template: `<ng-container #container></ng-container>`,
    styles: ''
} )
export class DynamicListComponent implements OnChanges {
    /**
     * doPagingList
     * @type {*}
     */
    @Output() doPagingList = new EventEmitter();
    /**
     * list items
     * @public
     * @type {ComponentItem[]}
     */
    @Input() public listItems: ComponentItem[] = [];

    /**
     * inject breakpointservice
     * @type {*}
     */
    #breakpointService = inject( BreakpointService );
    /**
     * isMobile check
     * @type {*}
     */
    isMobile = computed( () => this.#breakpointService.currentScreenSize() === 'XSmall' );

    /**
     * viewContainerRef
     * @type {*}
     */
    @ViewChild( 'container', { read: ViewContainerRef, static: true } ) containerRef!: ViewContainerRef;

    /**
     * update showListItems on Change
     */
    ngOnChanges(): void {
        this.showListItems();
    }

    /**
     * showListItems function
     * @private
     */
    private showListItems() {
        if ( !this.containerRef || this.listItems.length === 0 ) return;

        this.containerRef.clear();

        this.listItems.forEach( ( listItem ) => {
            if ( !listItem.type ) return; // Ensure the item has a valid component type

            const componentRef = this.containerRef.createComponent<DynamicComponent>( listItem.type );
            componentRef.instance.content = listItem.data;
            componentRef.instance.isMobile = this.isMobile();
        } );
    }
}
